import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-home",
  "use": "icon-soc-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-home\">\r\n<g transform=\"translate(-61.440 -61.440) scale(1.120000)\">\r\n<path d=\"M512 128L896 448v448H640V640H384v256H128V448L512 128zm0 118L224 496v336h96V576h384v256h96V496L512 246z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-home.svg
// module id = 1ecj
// module chunks = 396